import React from 'react';
import { Tag } from 'antd';
import { HttpMethod } from '../types';

interface MethodBadgeProps {
  method: HttpMethod;
}

const METHOD_COLORS: Record<HttpMethod, string> = {
  GET: 'blue',
  POST: 'green',
  PUT: 'orange',
  PATCH: 'gold',
  DELETE: 'red',
};

export const MethodBadge: React.FC<MethodBadgeProps> = ({ method }) => {
  return (
    <Tag color={METHOD_COLORS[method]} style={{ fontWeight: 600, fontSize: '12px' }}>
      {method}
    </Tag>
  );
};

export default MethodBadge;
